var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 fill-height d-flex justify-center align-center flex-column card-circle pa-4"},[_c('EllipseProgress',{attrs:{"value":_vm.value,"size":_vm.size,"legend":false,"color":_vm.color}}),_c('div',{staticClass:"mt-4 w-80 text-center"},[_c('span',[_vm._v(_vm._s(_vm.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }